import { Article } from '@/models/Article';
import PQueue from 'p-queue';

export default {
	data() {
		return {
			editArticle: { show: false, article: null, width: 800 },
			imageUpload: { show: false, article: null },
			addReprints: { show: false, article: null },
			selected: [],
			articlesListLoading: false, /** @todo Not used, to be removed */
			queue: new PQueue({ concurrency: 2 }),
		};
	},
	computed: {
		articles() {
			return this.$store.get('articles');
		},
	},
	created() {
		this.changeView = JSON.parse(localStorage.getItem('cardStyle_articles')) || 0;
	},
	methods: {
		// article could be an Article object or an Article ID
		setEditArticle(article) {
			if (Number.isInteger(article)) {
				// Article ID has been passed
				const articleId = article;
				// Check if article exists in store already
				const storeArticle = this.articles.find(article => article.id === articleId);
				if (storeArticle) {
					article = storeArticle;
				}
				else {
					// else fetch it
					article = new Article();
					article.id = articleId;
					article.fetch().catch(() => this.$notify('error', 'Failed to get article.'));
				}
			}

			this.editArticle.article = article;
			this.editArticle.show = true;
		},
		removeArticleFromStore(article) {
			const articles = this.articles;
			const deleteIndex = articles.indexOf(article);
			if (deleteIndex > -1) {
				articles.splice(deleteIndex, 1);
			}
		},
		updateSocialStats(article) {
			article.updateSocial().then(() => {
				this.$notify('success', 'Social stats have been updated.');
			}).catch(() => {
				this.$notify('error', 'Failed to update social stats');
			});
		},
		confirmThenDeleteArticle(article) {
			const reportName = this.$store.get('reports/currentReport').displayName;
			this.$refs.confirm.createConfirm(`This will delete "${article.titleText}" in "${reportName}".`, 'error').then((answer) => {
				if (!answer) {
					return;
				}
				this.deleteArticle(article);
			});
		},
		// Duplicated in Articles collection
		deleteArticle(article) {
			// For Edit Article screen actions
			this.$emit('close-edit-article-window');

			this.articlesListLoading = true;

			const title = article.title || '(no title article)';
			article.delete().then(() => {
				// just added articles are not auto removed from collection
				if (article) {
					this.removeArticleFromStore(article);
				}
				this.$notify('success', `"${title}" has been deleted.`);
			}).catch(() => {
				this.$notify('error', `Failed to delete "${title}"`);
			}).finally(() => {
				this.articlesListLoading = false;
			});
		},
		// Duplicated in Articles collection
		moveTo(report, category, article) {
			// For Edit Article screen actions
			this.$emit('close-edit-article-window');

			this.articlesListLoading = true;

			const newCategory = category === 0 ? null : category;
			const ids = [article.id];

			report.moveArticles(ids, newCategory).then(() => {
				this.removeArticleFromStore(article);
				this.$notify('success', `Selected article moved to ${report.displayName}.`,
					{ name: 'ArticlesList', params: { reportId: report.id } });
			}).catch(() => {
				this.$notify('error', 'Selected article failed to moved.');
			}).finally(() => {
				this.articlesListLoading = false;
			});
		},
		// Duplicated in Articles collection
		copyTo(report, category, article) {
			// For Edit Article screen actions
			this.$emit('close-edit-article-window');

			this.articlesListLoading = true;

			const newCategory = category === 0 ? null : category;
			const ids = [article.id];

			report.copyArticles(ids, newCategory).then(() => {
				this.$notify('success', `Selected article copied to ${report.displayName}.`,
					{ name: 'ArticlesList', params: { reportId: report.id } });
			}).catch(() => {
				this.$notify('error', 'Selected article failed to copy.');
			}).finally(() => {
				this.articlesListLoading = false;
			});
		},
		// Duplicated in Articles collection
		moveSelected(report, category) {
			this.articlesListLoading = true;

			const articleMessage = this.selected.length > 1 ? 'articles' : 'article';
			const newCategory = category === 0 ? null : category;
			const ids = this.selected.map(article => article.id);

			report.moveArticles(ids, newCategory).then(() => {
				for (let i = this.selected.length; i >= 0; i--) {
					this.removeArticleFromStore(this.selected[i]);
				}
				this.selected = [];
				this.$notify('success', `Selected ${articleMessage} moved to ${report.displayName}.`,
					{ name: 'ArticlesList', params: { reportId: report.id } });
			}).catch(() => {
				this.$notify('error', `Selected ${articleMessage} failed to move.`);
			}).finally(() => {
				this.articlesListLoading = false;
			});
		},
		// Duplicated in Articles collection
		copySelected(report, category) {
			this.articlesListLoading = true;

			const articleMessage = this.selected.length > 1 ? 'articles' : 'article';
			const newCategory = category === 0 ? null : category;
			const ids = this.selected.map(article => article.id);

			report.copyArticles(ids, newCategory).then(() => {
				this.selected = [];
				this.$notify('success', `Selected ${articleMessage} copied to ${report.displayName}.`,
					{ name: 'ArticlesList', params: { reportId: report.id } });
			}).catch(() => {
				this.$notify('error', `Selected ${articleMessage} failed to copy.`);
			}).finally(() => {
				this.articlesListLoading = false;
			});
		},
		// Duplicated in Articles collection
		deleteSelectedItems() {
			const report = this.$store.get('reports/currentReport');
			const articleMessage = this.selected.length > 1 ? 'articles' : 'article';
			const selectedCount = this.selected.length === this.articles.length ? 'ALL' : this.selected.length;
			this.$refs.confirm.createConfirm(`This will delete ${selectedCount} ${articleMessage} in ${report.displayName}.`, 'error')
				.then((answer) => {
					if (!answer) {
						return;
					}
					this.articlesListLoading = true;
					const ids = this.selected.map(article => article.id);

					report.deleteArticles(ids).then(() => {
						for (let i = this.selected.length; i >= 0; i--) {
							this.removeArticleFromStore(this.selected[i]);
						}
						this.selected = [];
						this.$notify('success', `Selected ${articleMessage} deleted`);
					}).catch(() => {
						this.$notify('error', `Selected ${articleMessage} failed to delete.`);
					}).finally(() => {
						this.articlesListLoading = false;
					});
				});
		},
		// Duplicated in Articles collection
		changeCategorySelected(category) {
			const articleMessage = this.selected.length > 1 ? 'articles' : 'article';
			let showError = false;
			this.articlesListLoading = true;

			this.selected.forEach((article) => {
				if (category !== 0) {
					article.categoryId = category;
				}
				this.queue.add(() => article.save().catch(() => {
					showError = true;
				}));
			});
			this.queue.onIdle().then(() => {
				this.articlesListLoading = false;
				this.selected = [];
				if (showError) {
					this.$notify('error', `Selected ${articleMessage} failed to change categories.`);
				}
				else {
					this.$notify('success', `Selected ${articleMessage} categories changed.`);
				}
			});
		},
		setReportImage(image) {
			const report = this.$store.get('reports/currentReport');
			report.image = image;
			//report.skipValidation = true;
			report.setOption('validateOnSave', false);
			report.save().then(() => {
				this.$notify('success', `Image changed for ${report.displayName}`);
			}).catch((e) => {
				dump(e);
				report.reset();
				this.$notify('error', `Failed to change image for ${report.displayName}`);
			});
			report.setOption('validateOnSave', true);
		},
		setProjectImage(image) {
			const project = this.$store.get('projects/currentProject');
			const projects = this.$store.get('projects/active');
			project.image = image;
			project.save().then(() => {
				// If you enter a project via direct url, must set the project image manually as current
				// project was fetched instead of being a reference to a projecting in store projects.
				const found = projects.find(storeProject => storeProject.id === project.id);
				if (found) {
					found.image = image;
				}
				this.$notify('success', `Image changed for ${project.name}`);
			}).catch(() => {
				project.reset();
				this.$notify('error', `Failed to change image for ${project.name}`);
			});
		},
		setImageUpload(article) {
			this.imageUpload.article = article;
			this.imageUpload.show = true;
		},
		setAddReprints(article) {
			this.addReprints.article = article;
			this.addReprints.show = true;
		},
	},
};
